export default "__VITE_PUBLIC_ASSET__412326f1__"